export const generateRentOptions = (start: number, end: number, step: number): number[] => {
  const options: number[] = []
  for (let value = start; value <= end; value += step) {
    options.push(value)
  }
  return options
}
